
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSimplifiedBuoyCardinalNorth as ObiSimplifiedBuoyCardinalNorthElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-simplified-buoy-cardinal-north.js';
 
 
 

 
 export const ObiSimplifiedBuoyCardinalNorth = createComponent({
   react: React,
   tagName: 'obi-simplified-buoy-cardinal-north',
   elementClass: ObiSimplifiedBuoyCardinalNorthElement,
   events: {
     
   }
  });
 
 